import React, { useCallback, useState } from "react";
import PropTypes from "prop-types";
import Share from "@washingtonpost/wpds-assets/asset/share";
import { Icon } from "@washingtonpost/wpds-icon";
import { Button } from "@washingtonpost/wpds-button";
import { canShareNatively, openNativeShareTool } from "./utils";
import { CopyButton } from "./CopyButton";
import "../index.css";
import useDevice from "../../../../common/hooks/useDevice";
import { BreakPoints } from "../../../../utils/device-helper";

export const ShareButton = ({
  headline,
  canonicalUrl: url,
  setSelected,
  isMiniPlayer
}) => {
  const isMobileSize = useDevice() === BreakPoints.MOBILE;
  const useNativeShare =
    canShareNatively({ title: headline, url }) && isMobileSize;

  const [nativeShareOpen, setNativeShareOpen] = useState(false);

  const handleNativeShare = useCallback(() => {
    if (nativeShareOpen) return;
    setNativeShareOpen(true);
    openNativeShareTool({ title: headline, url })
      .then(() => {
        setNativeShareOpen(false);
      })
      .catch(() => {
        setNativeShareOpen(false);
      });
  }, [headline, url, nativeShareOpen]);

  return (
    <>
      {useNativeShare ? (
        <Button
          icon="center"
          variant="primary"
          css={{
            border: "none",
            background: "none",
            "&:hover": {
              background: "none"
            },
            margin: "-$075",
            padding: "$075"
          }}
          data-testid="share-button"
          onFocus={() => {
            setSelected(true);
          }}
          onClick={e => {
            e.stopPropagation();
            useNativeShare && handleNativeShare();
          }}
        >
          <Icon fill="white" size="150" label="share">
            <Share />
          </Icon>
        </Button>
      ) : (
        <CopyButton isMiniPlayer={isMiniPlayer} content={url} />
      )}
    </>
  );
};

ShareButton.displayName = "ShareButton";

ShareButton.propTypes = {
  /** The headline to pass to social media share links */
  headline: PropTypes.string.isRequired,
  /** The canonical URL to pass to social media share links */
  canonicalUrl: PropTypes.string.isRequired,
  /** Function to set the selected state */
  setSelected: PropTypes.func,
  /** Boolean to determine if the player is in mini player mode */
  isMiniPlayer: PropTypes.bool.isRequired
};
